import { Container, Grid, Link, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

export const OverCreditLimit = ({ state: { accountInfo } }): JSX.Element => (
  <Grid rowsGap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="reduce-credit-limit" size="92" />
    <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
      We noticed that you're currently over your credit limit
    </Text>
    <Text>
      To reduce your credit limit, you must first pay your account balance below
      your desired credit limit.
    </Text>
    <Container>
      <Link appearance="primary-button" href="/" newTab={false}>
        Go to overview
      </Link>
    </Container>
  </Grid>
);
